import { render, staticRenderFns } from "./AddCareerStudentModal.vue?vue&type=template&id=e8c44b24&scoped=true&"
import script from "./AddCareerStudentModal.vue?vue&type=script&lang=js&"
export * from "./AddCareerStudentModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCareerStudentModal.vue?vue&type=style&index=0&id=e8c44b24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c44b24",
  null
  
)

export default component.exports